<template>
  <div
    class="dd-container"
    @contextmenu="handlePaste($event)"
  >
    <nuxt-link :to="localePath('/')">
      <h1 class="dd-logo"></h1>
    </nuxt-link>

    <div class="container">
      <div class="left">
        <p class="name">{{detail.name}}</p>

        <p class="nationality">
          <span v-if="detail.birth">{{detail.birth}}</span>
          <span
            class="vline"
            v-if="detail.birth"
          >|</span>
          <span>{{detail.nationality}}</span>
        </p>

        <p
          class="opus-name"
          v-if="activeItem.name"
        >{{activeItem.name}}</p>
        <p
          class="years"
          v-if="activeItem.years"
        >{{activeItem.years}}</p>
        <p
          class="materialQuality"
          v-if="activeItem.materialQuality"
        >{{activeItem.materialQuality}}</p>
        <p
          class="size"
          v-if="activeItem.size"
        >{{activeItem.size}}</p>
      </div>

      <div class="right">
        <Banner
          :list="detail.items"
          @change-item="handleChangeItem"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Divider } from 'vant'
import Banner from '@pc/artists/Banner'

export default {
  layout: 'empty-default',
  computed: {
    ...mapState('artist', ['detail', 'activeItem'])
  },

  components: {
    [Divider.name]: Divider,
    Banner
  },

  async fetch ({ store, app, params }) {
    await store.dispatch('artist/getDetail', {
      id: params.id,
      app
    })
  },

  methods: {
    handleChangeItem (item = {}) {
      this.$store.commit('artist/SET_ACTIVE_ITEM', item || {})
    },

    handlePaste (event) {
      // 禁用鼠标右键
      event.preventDefault()
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  margin-top: 36px;
  margin-bottom: 50px;

  .left {
    width: 250px;

    .name {
      margin-bottom: 12px;
      color: #000000;
      font-weight: bold;
      font-size: 28px;
      line-height: 40px;

      @include clamps-text-overflow(3);
    }

    .nationality {
      display: flex;
      align-items: center;
      margin-bottom: 36px;
      color: #5e5e5e;
      font-size: 14px;

      @include clamps-text-overflow(1);

      .vline {
        margin: 0 4px;
      }
    }

    .opus-name {
      margin-bottom: 30px;
      color: #000000;
      font-weight: bold;
      font-size: 18px;
      line-height: 24px;

      @include clamps-text-overflow(3);
    }

    .years,
    .materialQuality,
    .size {
      color: #000000;
      font-size: 14px;
      line-height: 24px;
    }

    .intro-wrap {
      .intro {
        overflow: hidden;
        margin-bottom: 30px;
        max-height: 100px;

        &.intro-expand {
          overflow: auto;
          max-height: inherit;
        }
      }
    }

    .exhibit-wrap {
      .exhibit {
        overflow: hidden;
        margin-top: 40px;
        margin-bottom: 30px;
        max-height: 250px;

        &.exhibit-expand {
          overflow: auto;
          max-height: inherit;
        }
      }
    }

    ::v-deep {
      .van-divider::before,
      .van-divider::after {
        border-width: 3px 0 0;
      }

      .icon {
        font-size: 22px;
      }
    }
  }

  .right {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
  }
}

.dd-logo {
  display: block;
  margin-top: 37px;
  width: 108px;
  height: 33px;
  background: url('~assets/img/common/logo-default.png') center/100% no-repeat;
}
</style>
